<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'ProductTemplate',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'number',
        placeholder: '编号',
        type: 'input'
      },{
        name: 'title',
        placeholder: '标题',
        type: 'input'
      }],
      permission: {
        add: 'productTemplate:add',
        update: 'productTemplate:update',
        delete: 'productTemplate:delete',
        deleteBatch: 'productTemplate:deleteBatch'
      },
      url: {
        get: '/productTemplate/listByCondition',
        add: '/productTemplate/add',
        update: '/productTemplate/update',
        delete: '/productTemplate/delete',
        delete_batch: '/productTemplate/deleteBatch',
        status: '/productTemplate/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },
        {
          field: 'number',  // 字段名
          label: '编号',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'title',  // 字段名
          label: '标题',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },{
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'number',  // 字段名
            label: '编号',  // 字段显示名称
            type: 'input',
            placeholder: '请输入编号',
            rules: [
              {required: true, message: '编号不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'title',  // 字段名
            label: '标题',  // 字段显示名称
            type: 'input',
            placeholder: '请输入标题',
            rules: [
              {required: true, message: '标题不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
